export enum PaymentStatus {
  CREATED = 'CREATED',
  QUEUED = 'QUEUED',
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  FAILED = 'FAILED',
  DONE = 'DONE'
}
